import { _API, _AXIOS_HELPER, _HEADER } from '@/static';
import * as ENUM from "@/enum/lib";

export default {
    getPatientPublicNoteListByLimit: function ( seqMedicalRelation, startIndex, isPublic, size ) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/managerNote/list';     //API에서 알맞는 PATH를 지정해 줍니다.
            const conf = {
                headers: _HEADER()
            };
            const data = { seqMedicalRelation, startIndex, isPublic, size };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } )
    },

    insertPatientPublicNote: function ( noteData, isPublic ) {
        const { seqMedicalRelation, noteTitle, noteContent, isImportant } = noteData
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/managerNote/add';     //API에서 알맞는 PATH를 지정해 줍니다.
            const conf = {
                headers: _HEADER()
            };
            const data = { seqMedicalRelation, noteTitle, noteContent, isImportant, isPublic };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } )
    },

    updatePatientPublicNote: function ( noteData, isPublic ) {
        const { seqManagerNote, noteTitle, noteContent, isImportant } = noteData;
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/managerNote/modify';     //API에서 알맞는 PATH를 지정해 줍니다.
            const conf = {
                headers: _HEADER()
            };
            const data = { seqManagerNote, noteTitle, noteContent, isImportant, isPublic };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.PUT, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } )
    },

    updateIsImportant: function ( data ) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/managerNote/important';     //API에서 알맞는 PATH를 지정해 줍니다.
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.PUT, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } )
    },

    deletePublicNote: function ( seqManagerNote ) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/managerNote/remove';     //API에서 알맞는 PATH를 지정해 줍니다.
            const conf = {
                headers: _HEADER()
            };
            const data = { seqManagerNote };

            _AXIOS_HELPER( ENUM.HTTP_METHOD.PUT, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } )
    }
}